import React, { useEffect, useState } from "react";
import { Card, Form, Input, Button, message, Spin, Flex } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import logo from "@/assets/akLogo.jpg";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import {
	selectIsSuccess,
	selectError,
	selectIsLoading,
} from "@/redux/slices/authSlice";
import { login } from "@/redux/services/authApi";
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [form] = Form.useForm();
	const [clientReady, setClientReady] = useState(false);
	const [messageApi, contextHolder] = message.useMessage();

	const isSuccess = useSelector(selectIsSuccess);
	const Error = useSelector(selectError);
	const isLoading = useSelector(selectIsLoading);

	// To disable submit button at the beginning.
	useEffect(() => {
		setClientReady(true);
	}, []);

	useEffect(() => {
		if (isSuccess) {
			navigate("/");
		}

		if (Error) {
			messageApi.open({
				type: "error",
				content: "登录失败",
			});
		}
	}, [Error, isSuccess, messageApi, navigate]);

	const onFinish = async (values) => {
		const { email, password } = values;
		dispatch(
			login({
				email: email,
				password: password,
			})
		);
	};

	return (
		<div className="login">
			{contextHolder}

			<Card className="login-container">
				<div className="login-div">
					<img className="login-logo" src={logo} alt="" />
					<span style={{ fontSize: "25px", fontWeight: "bold" }}>
						Welcome Back!{" "}
					</span>
					<span style={{ fontSize: "18px", fontWeight: "normal" }}>
						Login to your account
					</span>
				</div>
				{isLoading ? (
					<Flex justify="center" align="center">
						<Spin tip="Loading..." size="large"></Spin>
					</Flex>
				) : (
					<Form
						name={form}
						className="login-form"
						onFinish={onFinish}
					>
						<Form.Item
							name="email"
							rules={[
								{
									required: true,
									message: "Please input your email!",
								},
							]}
						>
							<Input
								prefix={
									<UserOutlined className="site-form-item-icon" />
								}
								placeholder="Email"
							/>
						</Form.Item>
						<Form.Item
							name="password"
							rules={[
								{
									required: true,
									message: "Please input your Password!",
								},
							]}
						>
							<Input
								prefix={
									<LockOutlined className="site-form-item-icon" />
								}
								type="password"
								placeholder="Password"
							/>
						</Form.Item>{" "}
						<div className="login-div">
							<Form.Item shouldUpdate>
								{() => (
									<Button
										className="login-button"
										type="primary"
										htmlType="submit"
										disabled={
											!clientReady ||
											!form.isFieldsTouched(true) ||
											!!form
												.getFieldsError()
												.filter(
													({ errors }) =>
														errors.length
												).length
										}
									>
										{" "}
										Log in
									</Button>
								)}
							</Form.Item>
						</div>
					</Form>
				)}
			</Card>
		</div>
	);
};

export default LoginPage;
